import { AlertTriangle } from "lucide-react";
import { CAT, CRITERIA, fmt, levelName } from "@/lib/ratings";

export default function AssessmentBreakdown({ a }) {
  return (
    <div className="rounded-2xl glow-border overflow-hidden" style={{ background: "var(--surface)" }} data-testid="assessment-breakdown">
      <div className="px-5 py-4 border-b flex items-center justify-between" style={{ borderColor: "var(--border)" }}>
        <span className="font-display font-bold">Assessment Rating</span>
        <span className="font-display font-black text-2xl tabular-nums" data-testid="breakdown-total">{fmt(a.rating)} <span className="text-sm text-primary-c">{levelName(a.rating)}</span></span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[480px] text-sm">
          <thead>
            <tr className="text-[10px] uppercase tracking-wider" style={{ color: "var(--text-2)" }}>
              <th className="text-left px-5 py-2 font-bold">Category</th><th className="px-2 font-bold">Weight</th>
              <th className="px-2 font-bold">Ratings</th><th className="px-2 font-bold">Average</th><th className="px-5 text-right font-bold">Contribution</th>
            </tr>
          </thead>
          <tbody>
            {a.breakdown.map((b) => (
              <tr key={b.category} className="border-t" style={{ borderColor: "var(--border)" }} data-testid={`breakdown-${b.category}`}>
                <td className="px-5 py-3 font-semibold whitespace-nowrap">{CAT[b.category].label}</td>
                <td className="px-2 text-center mono">{Math.round(b.weight * 100)}%</td>
                <td className="px-2 text-center mono" data-testid={`breakdown-${b.category}-count`}>{b.count}</td>
                <td className="px-2 text-center mono">{fmt(b.average)}{b.average != null && <span className="block text-[10px] font-sans" style={{ color: "var(--text-2)" }}>{levelName(b.average)}</span>}</td>
                <td className="px-5 text-right mono">{b.contribution == null ? "—" : b.contribution.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {a.provisional && (
        <div className="px-5 py-3 border-t flex gap-2 text-xs" style={{ borderColor: "var(--border)", color: "#f59e0b" }} data-testid="assessment-provisional-note">
          <AlertTriangle className="w-4 h-4 shrink-0" />
          <span>Incomplete — no ratings yet from {a.missing.map((m) => `${CAT[m].short} (${CAT[m].pct})`).join(", ")}. Weights are never redistributed; {a.rating == null ? "no value yet." : `the value shown covers only ${Math.round(a.coverage * 100)}% of the fixed weighting.`}</span>
        </div>
      )}
      {a.total > 0 && (
        <div className="px-5 py-4 border-t grid grid-cols-2 sm:grid-cols-5 gap-3" style={{ borderColor: "var(--border)" }}>
          {CRITERIA.map(([k, l]) => (
            <div key={k} className="rounded-xl glass px-3 py-2">
              <div className="font-display font-black text-lg tabular-nums">{a.criteria[k] ?? "—"}<span className="block text-[10px] font-sans font-bold text-primary-c">{levelName(a.criteria[k])}</span></div>
              <div className="text-[10px] uppercase tracking-wider leading-tight" style={{ color: "var(--text-2)" }}>{l}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
